export default function CanonicalLinkTag({ name }: { name: string }) {
  // Create a URL object
  const url = new URL(`https://citizenshipper.com/${name}`)

  // Extract the origin and pathname to remove query parameters
  const cleanURL = `${url.origin}${url.pathname}`

  return <link rel="canonical" href={cleanURL} />
}
